module.exports = __webpack_public_path__ + "static/media/User.566d8619.png";